<template>
	<div id="videoall">
		<!--m3u8视频-->
		<div class="videoBox" v-show="!isChoose">
			<video
				ref="videoPlayer"
				loop
				muted
				controls
				autoplay
				preload="auto"
				id="videoss"
				class="videoss video-js vjs-default-skin vjs-big-play-centered"
			></video>
			<div class="mb" @click="changeType"></div>
		</div>
		<!-- <div> -->
		    <iframe
			v-show="isChoose"
			:src="getFrame()"
			width="100%"
			height="100%"
			frameBorder="0"
			marginHeight="0"
			marginWidth="0"
			style="
					position: absolute;
					background: block,
					z-index: -1;
					top: 0;
					left: 0;
					isibility: inherit;
					filter: alpha(opacity=0);
					width: 100%;
					height: 100%;
				"
		/>
		<!-- 在此处编写被覆盖的布局 -->
		<!-- </div> -->

		<!-- 不能播放 -->
		<!-- <div class="noPlay">
			<div class="noAV">
				<div class="img">
					<img src="../assets/img/right/shipin.png" alt="" />
				</div>
				<div class="txt">播放失败</div>
			</div>
		</div> -->
	</div>
</template>

<script>
import videojs from 'video.js'
import 'video.js/dist/video-js.css'
export default {
	data() {
		return {
			isChoose: false,
			videoUrl: '',
			videoPlayer: null,
			options: {
				controls: true, // 是否显示控制条
				muted: true, //是否静音
				autoplay: true, //自动播放
				loop: true, //是否循环
				fluid: false, // 自适应宽高
				language: 'zh-CN', // 设置语言
				// aspectRatio: '3:1',
				inactivityTimeout: false,
				controlBar: {
					// 设置控制条组件
					/* 设置控制条里面组件的相关属性及显示与否
		    'currentTimeDisplay':true,
		    'timeDivider':true,
		    'durationDisplay':true,
		    'remainingTimeDisplay':false,
		    volumePanel: {
		      inline: false,
		    }
		    */
					/* 使用children的形式可以控制每一个控件的位置，以及显示与否 */
					children: [
						{ name: 'playToggle' }, // 播放按钮
						{ name: 'currentTimeDisplay' }, // 当前已播放时间
						{ name: 'progressControl' }, // 播放进度条
						{ name: 'durationDisplay' }, // 总时间
						{
							// 倍数播放
							name: 'playbackRateMenuButton',
							playbackRates: [0.5, 1, 1.5, 2, 2.5],
						},
						{
							name: 'volumePanel', // 音量控制
							inline: false, // 不使用水平方式
						},
						{ name: 'FullscreenToggle' }, // 全屏
					],
				},
				language: 'zh-CN',
				poster: '', //播放前显示的视频画面，播放开始之后自动移除
				preload: 'auto', //预加载
				// width: 650,
				// height: 330,
				techOrder: ['html5', 'flvjs', 'flash'], // 兼容顺序
				flvjs: {
					mediaDataSource: {
						isLive: false,
						cors: true,
						withCredentials: false,
					},
				},
				sources: [],
			},
		}
	},
	mounted() {
		let urls = 'http://221.13.155.38:7086/live/cameraid/1000038%241/substream/2.m3u8'
		this.$nextTick(() => {
			this.handelVideoUrl(urls)
		})
	},
	methods: {
		getFrame() {
			return (
				'./video.html?wmode=transparent&streamUrl=' +
				encodeURI('rtsp://221.13.155.38:9090/dss/monitor/param?cameraid=1000192%240&substream=1')
			)
		},
		handelVideoUrl(reloadUrl) {
			const _this = this
			if (reloadUrl) {
				this.videoUrl = reloadUrl
			}
			if (this.videoUrl) {
				this.options.sources = [this.makeUrlSource(this.videoUrl)]

				this.$nextTick(() => {
					this.isCanPlay = true
					this.videoPlayer = videojs(this.$refs.videoPlayer, {
						...this.options,
					})
					// this.play()
				})
			}
		},
		play() {
			this.videoPlayer.play()
		},
		pause() {
			this.videoPlayer.pause()
		},
		editUrl(src) {
			this.isCanPlay = true
			this.$nextTick(() => {
				this.videoPlayer.src(this.makeUrlSource(src))
			})
		},
		dispose() {
			if (this.videoPlayer) {
				this.videoPlayer.dispose()
			}
		},
		makeUrlSource(reloadUrl) {
			const url = reloadUrl.replace(/\s+/g, '')
			let sources = {}
			if (url.indexOf('rtmp') > -1) {
				//rtmp格式视频
				sources = [{ src: reloadUrl, type: 'rtmp/flv' }]
			} else if (url.lastIndexOf('.') > -1) {
				var playurl = url.substring(url.lastIndexOf('.') + 1)
				// console.log(playurl.split('?')[0])
				if (playurl === 'flv') {
					// console.log('flv格式视频')
					//flv格式视频
					sources = [{ src: reloadUrl, type: 'video/x-flv' }]
				} else if (playurl.split('?')[0] === 'flv') {
					//对**直播平台flv地址做特殊处理
					// console.log('flv格式视频')
					//flv格式视频
					sources = [{ src: reloadUrl, type: 'video/x-flv' }]
				} else if (playurl === 'm3u8') {
					//m3u8格式视频
					// console.log('m3u8格式视频')
					sources = [{ src: reloadUrl, type: 'application/x-mpegURL' }]
				} else {
					// console.log('其他格式视频')
					//其他格式视频
					sources = [{ src: reloadUrl, type: 'video/mp4' }]
				}
				return sources
			}
		},

		changeType() {
			console.log('changeType')
			this.isChoose = true
		},
	},
}
</script>

<style lang="scss" scoped>
#videoall {
	width: 800px;
	height: 600px;
	position: relative;
}
.videoBox {
	width: 100%;
	height: 100%;
	// background: black;
	position: relative;
	.videojs {
		position: relative;
		width: 100%;
		height: 100%;
		.video {
			width: 100%;
			height: 100%;
		}
		video {
			width: 100%;
			height: 100%;
		}
		.controls {
			transition: all 0.5s;
			position: absolute;
			bottom: 0;
			left: 0;
			width: 100%;
			height: 0%;
			background: rgba(0, 0, 0, 0.2);
			display: flex;
			justify-content: space-between;
			align-items: center;
			.showBox {
				cursor: pointer;
				width: 3.5%;
				height: 66%;
				margin-left: 4%;
				// background: url('../assets/img/right/out.png') no-repeat;
				background-size: 100% 100%;
			}
			.outBox {
				cursor: pointer;
				width: 3.5%;
				height: 66%;
				margin-left: 4%;
				// background: url('../assets/img/right/show.png') no-repeat;
				background-size: 100% 100%;
			}
			.fullBox {
				cursor: pointer;
				width: 3.5%;
				height: 66%;
				margin-right: 4%;
				// background: url('../assets/img/right/full.png') no-repeat;
				background-size: 100% 100%;
			}
		}
	}
	.videojs:hover .controls {
		height: 10%;
	}
	.noPlay {
		position: relative;
		width: 100%;
		height: 100%;
		// background-color: red;
		.noAV {
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translateX(-50%) translateY(-50%);
			width: 100px;
			height: 68px;
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			align-items: center;
			.img {
				width: 46px;
				height: 38px;
				img {
					width: 100%;
					height: 100%;
				}
			}
			.txt {
				font-size: 16px;
				color: white;
			}
		}
	}

	.mb {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
	}
}
.vjs_video_3-dimensions.vjs-fluid {
	padding: 0;
}
.vjs-fluid {
	padding: 0;
}
.vjs_video_542-dimensions.vjs-fluid {
	padding: 0;
}
</style>
<style>
.vjs-waiting .vjs-loading-spinner::after {
	display: none !important;
}
.vjs-control-text {
	display: none !important;
}
:focus {
	outline: -webkit-focus-ring-color auto 0px !important;
}
</style>
